import { WHY_WEXOZ } from "@/data/content";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { Stagger, Item } from "@/components/shared/Reveal";
import { Icon } from "@/components/shared/Icon";

export const WhyWexoz = () => (
  <section data-testid="why-wexoz-section" className="section relative">
    <div className="wrap">
      <SectionHeading eyebrow="Why Wexoz" title="One partner. Multiple technologies. One connected operation." />
      <Stagger className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-line bg-line sm:grid-cols-2 lg:grid-cols-3" stagger={0.07}>
        {WHY_WEXOZ.map((w, i) => (
          <Item key={w.title} data-testid={`why-item-${i + 1}`} className="group relative bg-navy p-8 transition-colors duration-300 hover:bg-navy-800 lg:p-10">
            <div className="flex items-center justify-between">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-line bg-navy-800 text-cyan-400 transition-colors group-hover:border-cyan-400/50">
                <Icon name={w.icon} className="h-5 w-5" />
              </span>
              <span className="font-mono text-xs text-slate-600">0{i + 1}</span>
            </div>
            <h3 className="mt-8 text-xl font-semibold">{w.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-400">{w.text}</p>
            <span className="absolute bottom-0 left-0 h-px w-0 bg-cyan-400 transition-[width] duration-500 group-hover:w-full" />
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
);
